export default function translate(i18n, libellePropriete) {
  let propriete = libellePropriete;
  if (propriete.includes('.')) {
    propriete = propriete.slice(propriete.indexOf('.') + 1);
  }
  if (propriete === 'dateDemande') {
    return i18n.t('editionDemandeImpression.validation.dateDemande');
  }
  if (propriete === 'etat') {
    return i18n.t('editionDemandeImpression.validation.etat');
  }
  if (propriete === 'campagneId') {
    return i18n.t('editionDemandeImpression.validation.campagne');
  }
  if (propriete === 'clientId') {
    return i18n.t('editionDemandeImpression.validation.client');
  }
  if (propriete === 'dispositifId') {
    return i18n.t('editionDemandeImpression.validation.dispositif');
  }
  if (propriete === 'societeId') {
    return '';
  }
  if (propriete === 'actionLogistique') {
    return 'suiviProduction.error.sujet';
  }
  if (propriete === 'typeOtId') {
    return i18n.t('editionDemandeImpression.validation.typeOt');
  }
  if (propriete === 'graphisteEnChargeId') {
    return i18n.t('editionDemandeImpression.validation.graphisteEnChargeId');
  }
  if (propriete === 'quantite') {
    return i18n.t('editionDemandeImpression.validation.quantite');
  }
  if (propriete === 'nomFichierRip') {
    return i18n.t('editionDemandeImpression.validation.nomFichierRip');
  }
  return propriete;
}
